module.exports = "/_next/static/images/6ddb7b633a0741f22052e6df91766fb4-phone-and-card@sm-1x.jpg.webp";